import { Box } from '#/components/Box/Box';
import { AnimatedCheckmark } from '#/components/Icon/AnimatedCheckmark';
import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

export function ListingViewAppliedMessage() {
  const { i18n } = useI18n();

  return (
    <Box display="flex" alignItems="center">
      <Box
        width={24}
        height={24}
        display="flex"
        justifyContent="center"
        alignItems="center"
        mr="8px"
        borderRadius="50%"
        bg={colors.brandGreen}
      >
        <AnimatedCheckmark size={12} colorName="white" />
      </Box>

      <BodySmall>{i18n('Thank you for applying!')}</BodySmall>
    </Box>
  );
}
